import { Injectable } from "@angular/core";
import { ProductModel } from "../../models/product/product.model";
import { ProductPopUpBaseService } from "./product-pop-up-base.service";

@Injectable({
    providedIn: "root"
})
export class DiscontinuedProductPopupService extends ProductPopUpBaseService<ProductModel> {

}
